import { Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BadgesComponent } from '@enginuity/core/molecules/badges/badges.component';
import { InputsComponent } from '@enginuity/core/molecules/inputs/inputs.component';
import { FormGroup, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-answers',
  templateUrl: './answers.component.html',
  styleUrls: ['./answers.component.scss'],
  imports: [CommonModule, FormsModule, BadgesComponent, InputsComponent, ReactiveFormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AnswersComponent),
      multi: true,
    },
  ],
})
export class AnswersComponent {
  @Input('formGroup') form!: FormGroup;
  @Input() numbring: boolean = false;
  selectedValue: string = '';
  @Input() input: boolean = false;

  @Input() flexDirection: boolean = false;

  @Input()
  width: 'full' | 'grid' = 'full';

  @Input() value = '';

  @Input() name = 'radio_name';

  @Input()
  answers: any = [
    {
      type: 'answer1',
      label: 'I sell my products to consumer',
      inputPlaceholder: 'Type the answer...',
      badgelabel: 'A',
    },
  ];

  @Output() selected = new EventEmitter<{ action: string; value: string }>();

  private onChange = (value: any) => {
    this.selected.emit({
      action: 'select',
      value,
    });
  };

  private onTouched: () => void = () => {};

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    // this.disabled = isDisabled;
  }
  onInputChange(value: any) {
    if (this.selectedValue === 'Other') {
      this.selected.emit({
        action: 'input',
        value,
      });
    } else {
      this.selected.emit({
        action: 'select',
        value,
      });
    }
    this.onChange(value);
    this.onTouched();
  }
  onRadioChange(value: any): void {
    this.selectedValue = value;
    if (value === 'Other') {
      // Prepare for taking additional input
    } else {
      this.onChange(value);
      this.onTouched();
      this.selected.emit({
        action: 'select',
        value,
      });
    }
  }
}
